import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pagination } from 'shared/common/types';

export interface ProjectStatusOutput {
  id: string;
  name: string;
  associatedState: number;
  color: string;
  priority: number;
}

@Injectable()
export class StatusService {
  constructor(private http: HttpClient) {}

  getProjectStatuses(projectId: string): Observable<ProjectStatusOutput[]> {
    return this.http.get<Pagination<ProjectStatusOutput>>(apiUrl(`/root/statuses/${projectId}`))
      .pipe(
        map(data => data.output),
      );
  }
}
